import { useEffect, useState } from "react";
import { upsertTag, uuidMapping } from "../helper";

const EMPTY_WEIGHT = {
  start_value: "",
  end_value: "",
};

export const useWeightFilter = (talentFilter, talentFilterTags, controlledValues) => {
  const [weightValues, setWeightValues] = useState(
    controlledValues ?? EMPTY_WEIGHT
  );

  useEffect(() => {
    if (controlledValues !== undefined) return;

    const attr = talentFilter?.person_attributes?.find(
      attribute => attribute && attribute.person_attribute_uuid === uuidMapping.weight
    );

    if (attr) {
      setWeightValues({ start_value: attr.start_value, end_value: attr.end_value });
    } else {
      clearWeight();
    }
  }, [talentFilter]);

  useEffect(() => {
    if (controlledValues === undefined) return;
    setWeightValues(controlledValues);
  }, [controlledValues?.start_value, controlledValues?.end_value]);

  const clearWeight = () => setWeightValues(EMPTY_WEIGHT);

  const start = parseInt(weightValues.start_value);
  const end = parseInt(weightValues.end_value);

  const isDisabled =
    isNaN(start) ||
    isNaN(end) ||
    end <= start;

  const buildWeightFilter = () => {
    if (isDisabled) return null;

    const weightAttribute = {
      person_attribute_uuid: uuidMapping.weight,
      contains: false,
      has_all_in_list: false,
      list: null,
      start_value: parseInt(weightValues.start_value),
      end_value: parseInt(weightValues.end_value),
    };

    const tags = upsertTag(talentFilterTags, uuidMapping.weight, weightValues);

    return { attribute: weightAttribute, tags };
  };

  return {
    weightValues,
    setMin: val => setWeightValues(weight => ({ ...weight, start_value: val })),
    setMax: val => setWeightValues(weight => ({ ...weight, end_value: val })),
    isDisabled,
    buildWeightFilter,
    clearWeight,
  };
};